const DEV = process.env.NODE_ENV === 'development';

import Swiper, {
	EffectFade,
	Navigation,
	Keyboard,
	HashNavigation,
} from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';

import gsap from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
gsap.registerPlugin(CustomEase);

export default {
	init() {
		// JavaScript to be fired on all pages
		console.log('init common');

		// Remove no-js
		document.documentElement.classList.remove('no-js');
		document.documentElement.classList.add('js');

		// Test touch
		if (!('ontouchstart' in document.documentElement)) {
			document.documentElement.classList.add('no-touch');
		} else {
			document.documentElement.classList.add('touch');
		}

		jQuery(document).ready(function ($) {
			var $body = $('body'),
				$header = $('.main_header'),
				$main = $('main'),
				swiperProjects = null;

			$('.js-toggle-open').bind('click', function (e) {
				e.preventDefault();
				var $this = $(this),
					tg = $this.attr('data-target'),
					bodyClass = $this.attr('data-bodyclass'),
					h = $this.hasClass('active') ? 0 : 'auto';

				$this.toggleClass('active');
				$body.toggleClass(bodyClass);
				gsap.to(tg, {
					height: h,
					duration: 0.5,
					ease: CustomEase.create('custom', '0.47, 0, 0.03, 1'),
				});
			});

			$('.js-menu-click').bind('click', function () {
				$body.css('overflow', 'hidden');
				hideElements();
			});

			let $projectOverlay = $('#projectOverlay'),
				$projectContainer = $('#projectContent');

			if ($projectOverlay.length <= 0) setProjectSwipers();

			$('.js-open-project').bind('click', function (e) {
				e.preventDefault();
				var $this = $(this);
				var url = $this.attr('href'),
					slide = $this.attr('data-slide') || 0,
					title = $this.attr('data-title') || '',
					type = $this.attr('data-type') || '';
				if (url) {
					openProject(url, slide, title, type);
				}
			});

			$('.js-close-project').bind('click', function (e) {
				e.preventDefault();
				closeProject();
			});

			function openProject(url, initialSlide, title, type) {
				hideElements();
				//$projectContainer.empty().removeClass('is-loaded');
				$projectContainer.empty();
				$('.project_title_name').text(title);
				$('.project_title_type').text(type);
				$projectContainer.load(url + ' #content', function () {
					$body.addClass('project--open');
					setProjectSwipers(initialSlide);
					history.pushState(null, null, url);
				});
			}

			function closeProject() {
				if ($projectOverlay) {
					$body.removeClass('project--open info--open');
					$('[data-classname="info--open"]').removeClass('active');
					showElements();
					setTimeout(function () {
						swiperProjects.destroy();
						history.back();
						window.location.hash = '';
					}, 1000);
				}
			}

			function hideElements() {
				gsap.to($header, {
					y: '-100%',
					delay: 0.3,
					duration: 1,
					ease: CustomEase.create('custom', '0.47, 0, 0.03, 1'),
				});
				gsap.to($main, {
					y: '100%',
					delay: 0.3,
					duration: 1,
					ease: CustomEase.create('custom', '0.47, 0, 0.03, 1'),
				});
			}

			function showElements() {
				gsap.to([$header, $main], {
					y: '0',
					delay: 1,
					duration: 1,
					ease: CustomEase.create('custom', '0.47, 0, 0.03, 1'),
				});
			}

			function setProjectSwipers(initialSlide) {
				if (swiperProjects) swiperProjects = null;
				swiperProjects = new Swiper('.project_swiper', {
					modules: [EffectFade, Navigation, Keyboard, HashNavigation],
					effect: 'fade',
					speed: 1,
					loop: true,
					initialSlide: initialSlide,
					keyboard: true,
					hashNavigation: {
						watchState: true,
						replaceState: true,
					},
					navigation: {
						prevEl: '.main_prev',
						nextEl: '.main_next',
					},
				});
			}
		});
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		console.log('finalize common');
	},
};
